import { phoneNumberRegEx, emailRegEx, linksRegEx } from 'utils/regex'

export const validLength = (value) => {
  return value.length <= 150
}

export const validFormat = (value) => {
  return typeof value === 'string'
}

export const validateDescriptionString = (value) => {
  let validationErrorType = ''
  if (phoneNumberRegEx().test(value)) {
    validationErrorType = 'telefonnummer'
  }
  if (emailRegEx().test(value)) {
    validationErrorType = validationErrorType
      ? `${validationErrorType}, email-adress`
      : 'email-adress'
  }
  if (linksRegEx().test(value)) {
    validationErrorType = validationErrorType ? `${validationErrorType}, länkar` : 'länkar'
  }
  return validationErrorType
}

export const getPotentialErrorMessage = (value) => {
  const formatValid = validFormat(value)
  const lengthValid = validLength(value)
  const validationErrorType = validateDescriptionString(value)

  let errorMessage = ''
  if (!formatValid) {
    errorMessage = 'Otillåtet format'
    return errorMessage // if bad content (not a string) just return this
  }
  if (validationErrorType) {
    errorMessage = `Otillåtet innehåll: ${validationErrorType}.`
  }
  if (!lengthValid) {
    errorMessage = 'Beskrivingen får max vara 150 tecken.'
  }
  if (validationErrorType && !lengthValid) {
    errorMessage = `Otillåtet innehåll: ${validationErrorType}. Max 150 tecken.`
  }
  return errorMessage
}
